import React, { useEffect, useState } from 'react'
import MaterialTable from 'material-table'
import {
  getUsuarios,
  postUsuario,
  getEmpresas,
  getRoles,
  editUsuario,
  postCambiarRol,
} from '@auteco/services/sostenibilidadService'
import { getPermissions } from '@auteco/utils/Common'

import {
  Select,
  MenuItem,
  Grid,
  TextField,
  Button,
  Card,
} from '@material-ui/core'
import { id } from 'date-fns/locale'
import SostenibilidadEmpresasContainer from '../SostenibilidadEmpresasContainer/SostenibilidadEmpresasContainer'

const SostenibilidadUsuariosContainer = () => {
  const [users, setUsers] = useState([])
  const [empresa, setEmpresa] = useState('')
  const [empresasList, setEmpresasList] = useState([])
  const [rolList, setRolList] = useState([])
  const [rol, setRol] = useState('')
  const [nombreUsuario, setNombreUsuario] = useState('')
  const [correoUsuario, setCorreoUsuario] = useState('')
  const [apellidoUsuario, setApellidoUsuario] = useState('')
  const [empresasShowing, setEmpresasShowing] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const permissions = getPermissions()

  const columns = [
    { title: 'Nombre', field: 'nombre' },
    { title: 'Email', field: 'correo' },
    {
      title: 'Rol',
      field: 'sostenibilidad_rol_id',
      render: (rowData) => {
        const rolF = rolList.find(
          (rolT) => rolT.id === rowData.sostenibilidad_rol_id,
        )
        return rolF ? rolF.nombre : 'Desconocido'
      },
      editComponent: ({ value, onChange }) => (
        <Select
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          fullWidth
        >
          {rolList.map((rolItem) => (
            <MenuItem key={rolItem.id} value={rolItem.id}>
              {rolItem.nombre}
            </MenuItem>
          ))}
        </Select>
      ),
    },
    {
      title: 'Empresa',
      field: 'empresa_id',
      render: (rowData) => {
        const empresaF = empresasList.find(
          (empresaT) => empresaT.id === rowData.empresa_id,
        )
        return empresaF ? empresaF.nombre : 'Desconocida'
      },
      editComponent: ({ value, onChange }) => (
        <Select
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          fullWidth
        >
          {empresasList.map((empresaItem) => (
            <MenuItem key={empresaItem.id} value={empresaItem.id}>
              {empresaItem.nombre}
            </MenuItem>
          ))}
        </Select>
      ),
    },
    {
      title: 'Activo',
      field: 'estado',
      render: (rowData) => (
        <p style={{cursor:"pointer"}} onClick={() => changeActive(rowData)}> {rowData.estado === '1' ? '🟢' : '🔴'}</p>
        ),
      type: 'boolean',
    },
  ]



  const handleGetUsuarios = async () => {
    const response = await getUsuarios()
    if (response) {
      setUsers(response.usuarios)
    }
  }

  const changeActive = async (rowData) => {
    setIsLoading(true)

    const response = await editUsuario({
      id: rowData.id,
      estado: rowData.estado === '1' ? '0' : '1',
    })
    if (response) {
      handleGetUsuarios()
    }
    setIsLoading(false)

  }

  const handleSave = async () => {
    setIsLoading(true)
    if (rol && empresa && correoUsuario && nombreUsuario && apellidoUsuario) {
      await postUsuario({
        nombre: nombreUsuario,
        apellido: apellidoUsuario,
        correo: correoUsuario,
        empresa_id: empresa,
        rol_id: rol,
      })
      handleGetUsuarios()
    } else {
      alert('Por favor diligencie todos los campos')
    }
    setIsLoading(false)
  }

  const handleEdit = async (newData) => {
    setIsLoading(true)
    const response = await editUsuario({
      id: newData.id,
      empresa_id: newData.empresa_id,
      rol_id: newData.sostenibilidad_rol_id,
    })
    const reponse2 = await postCambiarRol({
      usuario_id: newData.id,
      rol_id: newData.sostenibilidad_rol_id,
    })
    if (response && reponse2) {
      handleGetUsuarios()
    } else {
      alert('Error al editar el usuario')
    }
    setIsLoading(false)
  }

  const handleGetEmpresas = async () => {
    const response = await getEmpresas()
    if (response.empresas) {
      setEmpresasList(response.empresas)
    }
  }

  const handleGetRoles = async () => {
    const response = await getRoles()
    if (response.roles) {
      setRolList(response.roles)
    }
  }

  useEffect(() => {
    handleGetUsuarios()
    handleGetEmpresas()
    handleGetRoles()
  }, [])

  if (permissions[73] !== 5) {
    return (
      <div>
        <p>Permisos insuficientes</p>
      </div>
    )
  }

  return (
    <div>
      <div
        style={{
          fontSize: '20px',
          height: '30px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 'fit-content',
        }}
      >
        <p
          onClick={() => setEmpresasShowing(false)}
          style={{
            marginRight: '5px',
            cursor: 'pointer',
            width: '100px',
            color: empresasShowing ? 'grey' : 'white',
            textAlign: 'center',
            backgroundColor: 'black',
            marginBottom: '0',
            paddingTop: '5px',
          }}
        >
          Usuarios
        </p>
        <p
          onClick={() => setEmpresasShowing(true)}
          style={{
            cursor: 'pointer',
            backgroundColor: 'black',
            margin: '0',
            width: '100px',
            color: !empresasShowing ? 'grey' : 'white',
            textAlign: 'center',
            paddingTop: '5px',
          }}
        >
          Empresas
        </p>
      </div>

      {empresasShowing ? (
        <div>
          <SostenibilidadEmpresasContainer />
        </div>
      ) : (
        <div>
          <MaterialTable
            title="Listado de usuarios"
            data={users}
            columns={columns}
            className={`${isLoading ? 'my-loading' : ''}`}
            options={{
              headerStyle: {
                backgroundColor: '#35465c',
                color: 'white',
                fontSize: '14px',
                fontWeight: 700,
              },
            }}
            editable={{
              onRowUpdate: (newData, oldData) =>
                new Promise((resolve, reject) => {
                  try {
                    setTimeout(() => {
                      const dataUpdate = [...users]
                      const index = oldData.tableData.id
                      dataUpdate[index] = newData
                      console.log('newData', newData)
                      handleEdit(newData)
                      resolve()
                    }, 1000)
                  } catch (error) {
                    reject(error)
                  }
                }),
            }}
          />
          <br />
          <br />
          <Card>
            <div
              className={`${isLoading ? 'my-loading' : ''}`}
              style={{
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
              }}
            >
              <h3>Crear un usuario:</h3>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Nombre"
                value={nombreUsuario}
                onChange={(e) => setNombreUsuario(e.target.value)}
              />
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Apellido"
                value={apellidoUsuario}
                onChange={(e) => setApellidoUsuario(e.target.value)}
              />

              <TextField
                fullWidth
                type="email"
                variant="outlined"
                placeholder="Correo"
                value={correoUsuario}
                onChange={(e) => setCorreoUsuario(e.target.value)}
              />

              <Grid item xs={12}>
                <Select
                  value={empresa}
                  onChange={(e) => setEmpresa(e.target.value)}
                  displayEmpty
                  fullWidth
                >
                  <MenuItem value="" disabled>
                    Selecciona Empresa
                  </MenuItem>
                  {empresasList &&
                    empresasList.map((empresaItem) => (
                      <MenuItem key={empresaItem.id} value={empresaItem.id}>
                        {empresaItem.nombre}
                      </MenuItem>
                    ))}
                </Select>
              </Grid>

              <Grid item xs={12}>
                <Select
                  value={rol}
                  onChange={(e) => setRol(e.target.value)}
                  displayEmpty
                  fullWidth
                >
                  <MenuItem value="" disabled>
                    Selecciona Rol
                  </MenuItem>
                  {rolList &&
                    rolList.map((rolItem) => (
                      <MenuItem key={rolItem.id} value={rolItem.id}>
                        {rolItem.nombre}
                      </MenuItem>
                    ))}
                </Select>
              </Grid>

              <Button
                onClick={handleSave}
                fullWidth
                variant="contained"
                color="primary"
              >
                Guardar
              </Button>
            </div>
          </Card>
        </div>
      )}
    </div>
  )
}

export default SostenibilidadUsuariosContainer
